export default Object.freeze({
    QUOTAMANAGER: 0,
    TEAMDEFINITION: 1,
});
